/**
 * Dependencies
 */
import { isEqual, isEmpty } from 'lodash'

/**
 * Determine if the war room has files
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasFiles = (state) => {
    return state.data.files.length > 0
}

/**
 * Check if all files are selected
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const allFilesChecked = (state) => {
    let selected = state.selected.sort()
    let files = state.data.files.map(file => file.id).sort()

    return isEqual(selected, files)
}

/**
 * Check if the selected queue is empty
 *
 * @param  {Object} state [description]
 * @return {Boolean}       [description]
 */
const noFilesSelected = (state) => {
    return isEmpty(state.selected)
}

export default {
    hasFiles,
    noFilesSelected,
    allFilesChecked
}



// WEBPACK FOOTER //
// ./src/state/modules/war-room/getters.js